import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	list: [],
	selectedBusinessUnit: null,
	page: 1,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
	businessUnitsFetched: false,
};

const businessUnitsSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setBusinessUnitsData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;

			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil(totalItems / perPage);
		},

		setLoadingBusinessUnits: (state, action) => {
			state.loading = action.payload;
		},
		setSelectedBusinessUnit: (state, action) => {
			state.selectedBusinessUnit = action.payload;
		},
		setDeleteBusinessUnit: (state, action) => {
			state.data = state.data.filter((unit) => unit.id !== action.payload);
		},
		setAddBusinessUnit: (state, action) => {
			state.data.push(action.payload);
			state.totalItems += 1;
			state.totalPage = Math.ceil(state.totalItems / state.perPage);
		},
		setEditBusinessUnit: (state, action) => {
			const { id, updatedData } = action.payload;
			state.data = state.data.map((unit) => (unit.id === id ? { ...unit, ...updatedData } : unit));
		},
		setAllBusinessUnitsList: (state, action) => {
			const { data } = action.payload;

			state.list = data || [];
			state.businessUnitsFetched = true;
		},
	},
});

export const {
	setBusinessUnitsData,
	setLoadingBusinessUnits,
	setSelectedBusinessUnit,
	setDeleteBusinessUnit,
	setAddBusinessUnit,
	setEditBusinessUnit,
	setAllBusinessUnitsList,
} = businessUnitsSlice.actions;

export default businessUnitsSlice.reducer;
